<template>
  <div class="shortcut-info" :class="[`shortcut-info--size-${size}`]">
    <div class="shortcut-info__item" v-for="(item, index) in items" :key="index">
      <component :is="item" v-if="isIcon(item)" />

      <template v-else>
        {{ item }}
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { intersperse, has } from 'ramda';
import { shortcuts } from '@shortcuts/index';
import CommandIcon12 from '@components/Icons/CommandIcon12.vue';
import EnterIcon12 from '@components/Icons/EnterIcon12.vue';
import ShiftIcon12 from '@components/Icons/ShiftIcon12.vue';
import OptionIcon12 from '@components/Icons/OptionIcon12.vue';
import ControlIcon12 from '@components/Icons/ControlIcon12.vue';

const icons = {
  command: CommandIcon12,
  enter: EnterIcon12,
  shift: ShiftIcon12,
  alt: OptionIcon12,
  ctrl: ControlIcon12,
};

const isMac = navigator.platform.startsWith('Mac');

export default defineComponent({
  name: 'ShortcutInfo',

  components: {
    ...icons,
  },

  props: {
    shortcut: {
      type: String,
      required: true,
    },

    size: {
      type: String,
      default: 'medium',
    },
  },

  computed: {
    items() {
      const shortcut = shortcuts[this.shortcut];
      const original = Array.isArray(shortcut) ? shortcut[isMac ? 0 : 1] : shortcut;
      const text = original.replace(/ /g, '+'); // we display space as + in shortcuts
      const parts = text.split('+');
      const items = intersperse('+', parts);

      return items;
    },
  },

  methods: {
    isIcon(item: string) {
      return has(item, icons);
    },
  },
});
</script>

<style lang="scss">
@use 'settings/settings';

.shortcut-info {
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
  font-family: settings.$font-family-mono;
  font-weight: 400;
  line-height: 1;
  opacity: 0.7;

  svg {
    display: block;
    width: auto;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    opacity: 0.2;
    border: 1px solid;
  }
}

.shortcut-info--size-small {
  font-size: 10px;
  padding: 3px;
  height: 16px;
  border-radius: 4px;

  svg {
    height: 10px;
  }
}

.shortcut-info--size-medium,
.shortcut-info--size-large {
  font-size: 12px;
  padding: 4px;
  height: 20px;
  border-radius: 4px;

  svg {
    height: 12px;
  }
}
</style>
